import FormTemplate from "@Common/FormTemplate";
import OfferForm from "@Common/OfferForm";
import Share from "@Common/Share";
import { getSqlServerGuidHash, sendMetric, randomNumber, getWhatId, clearParamWithoutRerender, getAbTestMetrika, fixOrphans } from "@utils";
import dayjs from "dayjs";
import { computed } from "mobx";
import { inject, observer } from "mobx-react";
import { useState, useEffect } from "react";

import Timer from "../../../../../Modal/PromoModal/Default/Timer";

import Arrow from "../../img/arrow_black.svg";
import copyArrowBtnDark from "../../img/arrow_btn.svg";
import copyDark from "../../img/copy_dark.svg";
import copyGrey from "../../img/copy_grey.svg";

import "./style.scss";

const { VITE_WHAT_ID } = import.meta.env;

const Default = inject("mainStore")(
    observer(({ mainStore, item, isAccordionOpen, setIsAccordionOpen, id, handleClick = () => {}, type = false, typeLabel = "", title = "", cover = "" }) => {
        const abTest = computed(() => mainStore.getMainStore("abTest")).get();
        const abTestMetika = computed(() => mainStore.getMainStore("abTestMetika")).get();
        const wdCd = mainStore.getMainStore("codeTypeMetrika");
        const wdm = mainStore.getMainStore("codeWdm");
        const wd_mc = mainStore.getMainStore("codeWdMc");

        const [number, setNumber] = useState(5942);
        const [stateAnswer, setStateAnswer] = useState(0);
        const [open, setOpen] = useState(false);
        const [copyText, setCopyText] = useState(false);
        const [time, setTime] = useState("10:03");
        const [percentNumber, setPercentNumber] = useState(10);
        const [openDisclaimer, setOpenDisclaimer] = useState(false);

        const what_id = getWhatId() ? getWhatId() : VITE_WHAT_ID;
        const isAbTestMetrika = getAbTestMetrika(abTest, item?._id);
        const inputFields = item?.inputFields ?? [];
        const getInputFieldType = (field) => field?.type || field?.key;
        const hasPhoneField = inputFields.some((field) => getInputFieldType(field) === "phone");
        const hasOnlyEmailField = inputFields.length === 1 && getInputFieldType(inputFields[0]) === "email";
        const firstStepText = !inputFields.length ? "Нажмите “Получить подарок”" : hasOnlyEmailField ? "Укажите адрес своей почты ниже" : "Укажите свои данные ниже";
        const thirdStepText = hasPhoneField ? "Ожидайте звонка менеджера" : "Следуйте инструкции на сайте партнера";

        const termsOfUse =
            item && item.offerDetail && item.offerDetail?.termsOfUse ? item.offerDetail?.termsOfUse.replace(/{{dateEnd}}/gim, dayjs(item.dateEnd).format("DD.MM.YYYY")).replace(/{{dateStart}}/gim, dayjs(item.dateStart).format("DD.MM.YYYY")) : "";

        useEffect(() => {
            if (isAccordionOpen._id === item._id) {
                let el = document.getElementById(`${isAccordionOpen._id}`);
                if (el) {
                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }
        }, [isAccordionOpen]);

        useEffect(() => {
            let body = document.body;
            if (body && openDisclaimer) {
                body.style.overflow = "hidden";
                body.style["touch-action"] = "none";
                body.style["-webkit-overflow-scrolling"] = "none";
                body.style["overscroll-behavior"] = "none";
                body.style.width = "100%";
            } else {
                body.style = {};
            }
        }, [openDisclaimer]);

        useEffect(() => {
            if (localStorage.getItem(item._id)) {
                setNumber(parseInt(localStorage.getItem(item._id)));
                let timeHour = randomNumber(0, dayjs().subtract(2, "hour").format("HH"));
                let timeMinutes = randomNumber(10, 59);

                setTime(`${timeHour < 10 ? `0${timeHour}` : `${timeHour}`}:${timeMinutes}`);
            } else {
                let num = randomNumber(5000, 25000);
                let timeHour = randomNumber(0, dayjs().subtract(2, "hour").format("HH"));
                let timeMinutes = randomNumber(10, 59);

                setTime(`${timeHour < 10 ? `0${timeHour}` : `${timeHour}`}:${timeMinutes}`);

                localStorage.setItem(item._id, num);
                setNumber(num);
            }
        }, []);

        const handleOpen = () => {
            setOpen(!open);

            if (!open) {
                sendMetric(`click_offer_details`, {
                    params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                    params2: item._id,
                    params3: getSqlServerGuidHash(item.code, item.vendor?._id),
                    params4: item?.code,
                    params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                    params7: null,
                    params8: `${what_id}`,
                });
            }
        };

        const handleCopy = (e) => {
            e.stopPropagation();
            e.preventDefault();

            sendMetric(`click_offer_accepted_copy_code`, {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: item._id,
                params3: getSqlServerGuidHash(item.code, item.vendor?._id),
                params4: item?.code,
                params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                params7: null,
                params8: `${what_id}`,
            });

            navigator.clipboard.writeText(item.promoCode).then(() => {
                setCopyText("Скопирован в буфер");
                setTimeout(() => {
                    setCopyText(false);
                }, 1000);
            });
        };

        const clickBtnCopy = (e) => {
            e.stopPropagation();
            e.preventDefault();

            navigator.clipboard.writeText(item.promoCode).then(() => {
                setTimeout(() => {
                    if (!localStorage.getItem("first_click_offer_go_to_site")) {
                        sendMetric(`first_click_offer_go_to_site`, {
                            params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                            params2: item._id,
                            params3: getSqlServerGuidHash(item.code, item.vendor?._id),
                            params4: item?.code,
                            params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                            params7: null,
                            params8: `${what_id}`,
                        });

                        localStorage.setItem("first_click_offer_go_to_site", true);
                    }

                    sendMetric(`click_offer_accepted_copy_code_go_to_site`, {
                        params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                        params2: item._id,
                        params3: getSqlServerGuidHash(item.code, item.vendor?._id),
                        params4: item?.code,
                        params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                        params7: null,
                        params8: `${what_id}`,
                    });

                    if (window.risMetrika && typeof window.risMetrika.reachgoal_ch === "function") {
                        window.risMetrika.reachgoal_ch({
                            event: "click_offer_accepted_copy_code_go_to_site",
                            siteId: what_id, //'id витрины',
                            offerId: item?._id, //'id оффера'
                            variantCode: item?._ab_code, //'в оффере новый ключ _ab_code',
                            position: item?.positionIdx, //'Позиция оффера на витрине, не путать с сортировкой!!!' ,
                            sort: item?.sortNum, //'Сортировка оффера на витрине!!!' ,
                            session_uuid: localStorage.getItem("_r_p_s"),
                            widget_code: wdCd ? wdCd : "",
                            ml_traffic_mode: wdm ? wdm : "",
                            ml_model_code: wd_mc ? wd_mc : "",
                        });
                    }

                    const hrefOut = item && item.activationLink ? item.activationLink : false;

                    if (hrefOut) {
                        const a = document.createElement("a");
                        a.href = hrefOut;
                        a.target = "_blank";
                        a.click();
                        a.remove();
                    }
                }, 500);
            });
        };

        const clickBtn = (e) => {
            e.stopPropagation();
            e.preventDefault();
            if (!localStorage.getItem("first_click_offer_go_to_site")) {
                sendMetric(`first_click_offer_go_to_site`, {
                    params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                    params2: item._id,
                    params3: getSqlServerGuidHash(item.code, item.vendor?._id),
                    params4: item?.code,
                    params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                    params7: null,
                    params8: `${what_id}`,
                });
                localStorage.setItem("first_click_offer_go_to_site", true);
            }

            sendMetric(`click_offer_accepted_go_to_site`, {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: item._id,
                params3: getSqlServerGuidHash(item.code, item.vendor?._id),
                params4: item?.code,
                params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                params7: null,
                params8: `${what_id}`,
            });
            const hrefOut = item && item.activationLink ? item.activationLink : false;

            if (hrefOut) {
                const a = document.createElement("a");
                a.href = hrefOut;
                a.target = "_blank";
                a.click();
                a.remove();
            }
        };

        const handleInstruction = () => {
            sendMetric("click_instruction_offer", {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: `Клик на инструкцию по активации"`,
                params3: getSqlServerGuidHash(item.code, item.vendor?._id),
                params4: item?._id,
                params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                params7: null,
                params8: what_id,
            });
        };

        const handleClickGhost = () => {
            setIsAccordionOpen(false);
            clearParamWithoutRerender(["id", "code"]);

            sendMetric("click_offer_button_ghost_exit", {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: item._id,
                params3: getSqlServerGuidHash(item.code, item.vendor?._id),
                params4: item?.code,
                params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                params7: null,
                params8: what_id,
            });
        };

        return (
            <div className={`ab-3632 list-item__accordion ${type ? type : ""} `} id={item._id}>
                <div
                    className="list-item__accordion__content"
                    onClick={() => {
                        handleClick();
                        setStateAnswer(0);
                        setOpenDisclaimer(false);
                    }}
                >
                    <div className="list-item__accordion__logo">
                        <img alt={`logo_mobile`} className={`logo_mobile`} src={cover} />
                        <div className="list-item__accordion__title-container">
                            <span className={`list-item__accordion__title ${isAccordionOpen._id === item._id ? "big" : ""}`} dangerouslySetInnerHTML={{ __html: fixOrphans(title) }} />
                        </div>
                        {/* {isAccordionOpen._id === item._id ? <Share mobile={true} offer={item} /> : null} */}
                    </div>

                    {type === "hit" ? <span className={`list-item__accordion__hit-label_block ${type}`}>{typeLabel}</span> : null}

                    {isAccordionOpen._id === item._id ? null : (
                        <button className="list-item__accordion__mobile-button" type="button">
                            <span>Подробнее</span>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                                <path d="m3 6 5 5 5-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    )}
                </div>

                {isAccordionOpen._id === item._id ? (
                    item.promoCode ? (
                        item.ghostOffer ? (
                            <div className={`content__promo`}>
                                <div className="content__text">
                                    <span className="title">
                                        {item?.ghostOfferConfig && item.ghostOfferConfig.textAnswer ? item.ghostOfferConfig.textAnswer : "Как только предложение станет доступным, мы направим уведомление  на указанную Вами почту "}
                                    </span>
                                    <div className={`content__promo_button-close`} onClick={() => handleClickGhost()}>
                                        Выбрать другое предложение
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className={`content__promo`}>
                                {item.offerType !== "leads" ? (
                                    item.offerType === "partnerlink" ? (
                                        <section className="offer-steps" aria-labelledby="offer-steps-title">
                                            <h2 id="offer-steps-title">Как получить подарок:</h2>
                                            <ol>
                                                <li>
                                                    <span>1</span>
                                                    <p>Нажмите “Перейти на сайт”</p>
                                                </li>
                                                <li>
                                                    <span>2</span>
                                                    <p>Следуйте инструкции на сайте партнера</p>
                                                </li>
                                            </ol>
                                        </section>
                                    ) : (
                                        <section className="offer-steps" aria-labelledby="offer-steps-title">
                                            <h2 id="offer-steps-title">Как получить подарок:</h2>
                                            <ol>
                                                <li>
                                                    <span>1</span>
                                                    <p>{`Нажмите “Скопировать и перейти на сайт"`}</p>
                                                </li>
                                                <li>
                                                    <span>2</span>
                                                    <p>Нажмите «Получить подарок»</p>
                                                </li>
                                            </ol>
                                        </section>
                                    )
                                ) : (
                                    <section className="offer-steps-leads" aria-labelledby="offer-steps-title">
                                        <h2 id="offer-steps-title">Как получить подарок:</h2>
                                        <ol>
                                            <li>
                                                <span>1</span>
                                                <p>Ответьте на звонок менеджера</p>
                                            </li>
                                            <li>
                                                <span>2</span>
                                                <p>Договоритесь о записи на услугу</p>
                                            </li>

                                            <li>
                                                <span>3</span>
                                                <p>Придите в назначенные день и время</p>
                                            </li>
                                        </ol>
                                    </section>
                                )}
                                {
                                    item?.offerType && !["partnerlink", "leads"].includes(item.offerType) ? (
                                        <div className={`promo-code ${copyText ? "copy" : ""}`} onClick={(e) => handleCopy(e)}>
                                            <div className="promo-code-text">
                                                <span className="promo-code__label">Ваш промокод</span>
                                                <span>{copyText ? `${copyText}` : `${item.promoCode}`}</span>
                                            </div>

                                            <img alt={`promo-code`} src={copyText ? copyGrey : copyDark} />
                                        </div>
                                    ) : null
                                    // <div
                                    //     className="content__promo_button-close"
                                    //     onClick={() => {
                                    //         setIsAccordionOpen(false);
                                    //         clearParamWithoutRerender(["id", "code"]);
                                    //     }}
                                    // >
                                    //     Выбрать другие предложения
                                    //     <img alt={`promo-copy`} src={copyArrowBtnDark} width={21} />
                                    // </div>
                                }

                                {item.offerType !== "leads" ? (
                                    <div className="content__promo_copy" id="button_copy" onClick={item?.offerType !== "partnerlink" ? (e) => clickBtnCopy(e) : (e) => clickBtn(e)}>
                                        {item?.offerType !== "partnerlink" && item._id !== "662b6b30d07bd4eb3685f19b" && item._id !== "65af6c1623f7b941440758ec" ? "Скопировать и перейти на сайт" : "Перейти на сайт"}
                                        <img alt="content__promo_copy" src={copyArrowBtnDark} width={21} />
                                    </div>
                                ) : null}

                                {!item.activationLink.length ? (
                                    <div
                                        className={`content__promo_button-close`}
                                        onClick={() => {
                                            setIsAccordionOpen(false);
                                            clearParamWithoutRerender(["id", "code"]);
                                        }}
                                    >
                                        Выбрать еще предложения
                                    </div>
                                ) : null}
                                {item?.offerDetail?.miniDisc ? <div className="content__promo_instructions" onClick={handleInstruction} dangerouslySetInnerHTML={{ __html: item?.offerDetail.miniDisc }}></div> : null}

                                {item.ghostOffer ? null : <div className="content__offer_description" dangerouslySetInnerHTML={{ __html: item.description }}></div>}
                                {item.ghostOffer ? null : (
                                    <div className="content__offer_details_btn" onClick={(e) => handleOpen(e)}>
                                        <span>{open ? "Скрыть" : "Подробнee"}</span>
                                        {/* <img alt="content__offer_details_btn" src={Arrow} style={!open ? { transform: "rotate(180deg)" } : {}} /> */}
                                    </div>
                                )}
                                {item.ghostOffer ? null : open ? (
                                    <div className={`content__offer_info ${open ? "open" : ""}`}>
                                        <div className={`content__offer_info_activate `} dangerouslySetInnerHTML={{ __html: item?.offerDetail?.howToActivate || "" }}></div>
                                        <div className={`content__offer_info_details `}>
                                            <div className="container__all-conditions_text" dangerouslySetInnerHTML={{ __html: termsOfUse }}></div>
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        )
                    ) : (
                        <div className="content__offer">
                            {/* <div className={`content__offer_desc`}>
                                Сегодня это предложение забрали{" "}
                                <span>
                                    {number.toLocaleString()} человек{pluralForm(number, ["", "а", ""])}
                                </span>
                            </div> */}

                            <section className="content__offer-steps" aria-labelledby="content__offer-steps-title">
                                <h2 id="content__offer-steps-title">Как получить подарок:</h2>
                                <ol>
                                    <li>
                                        <span>1</span>
                                        <p>{firstStepText}</p>
                                    </li>
                                    <li>
                                        <span>2</span>
                                        <p>{item.inputFields.length ? "Нажмите «Получить подарок»" : "Мы направим вас на сайт партнера"}</p>
                                    </li>
                                    <li>
                                        <span>3</span>
                                        <p>{thirdStepText}</p>
                                    </li>
                                </ol>
                            </section>

                            {isAccordionOpen.formTemplate && stateAnswer < isAccordionOpen.formTemplate?.length ? (
                                <div className="form">
                                    {isAccordionOpen.formTemplate?.map((el, index) =>
                                        stateAnswer === index ? (
                                            <FormTemplate
                                                type={el.restrictionType}
                                                item={el}
                                                key={index}
                                                stateAnswer={stateAnswer}
                                                setStateAnswer={setStateAnswer}
                                                formTemplate={isAccordionOpen.formTemplate}
                                                offerId={item._id}
                                                surveyId={isAccordionOpen.surveyId}
                                                vendorId={item.vendor._id}
                                                index={index}
                                                promo={item}
                                                setIsAccordionOpen={setIsAccordionOpen}
                                                id={id}
                                                setPercentNumber={setPercentNumber}
                                                percentNumber={percentNumber}
                                                time={time}
                                                number={number}
                                            />
                                        ) : null,
                                    )}
                                </div>
                            ) : (
                                <OfferForm offerItem={isAccordionOpen} setIsAccordionOpen={setIsAccordionOpen} setPercentNumber={setPercentNumber} percentNumber={percentNumber} time={time} number={number} />
                            )}
                            {item.ghostOffer ? null : <div className="content__offer_description" dangerouslySetInnerHTML={{ __html: item.description }}></div>}
                            {item.ghostOffer ? null : (
                                <div className="content__offer_details_btn" onClick={(e) => handleOpen(e)}>
                                    <span>{open ? "Скрыть" : "Подробнee"}</span>
                                    {/* <img alt="content__offer_details_btn" src={Arrow} style={!open ? { transform: "rotate(180deg)" } : {}} /> */}
                                </div>
                            )}
                            {item.ghostOffer ? null : open ? (
                                <div className={`content__offer_info ${open ? "open" : ""}`}>
                                    <div className={`content__offer_info_activate `} dangerouslySetInnerHTML={{ __html: item?.offerDetail?.howToActivate || "" }}></div>
                                    <div className={`content__offer_info_details `}>
                                        <div className="container__all-conditions_text" dangerouslySetInnerHTML={{ __html: termsOfUse }}></div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    )
                ) : null}
            </div>
        );
    }),
);

export default Default;
